var slug = require('slug')

export default function (Vue) {
    Vue.prototype.slug = (item) => {
        return slug(item)
    }
}